import { render, staticRenderFns } from "./RadioGroupWithCustom.vue?vue&type=template&id=a5cfcc2a&scoped=true&"
import script from "./RadioGroupWithCustom.vue?vue&type=script&lang=ts&"
export * from "./RadioGroupWithCustom.vue?vue&type=script&lang=ts&"
import style0 from "./RadioGroupWithCustom.vue?vue&type=style&index=0&id=a5cfcc2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cfcc2a",
  null
  
)

export default component.exports